import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormField } from '../../redux/types';
import LabelledToggleField from '../base/LabelledToggleField';

interface Props {
  className?: string;
  disabled?: boolean;
  subLabel?: string;
}

const OfferDelayedStartToggle: React.FC<Props> = ({ className, disabled, subLabel }) => {
  const { t } = useTranslation();

  return (
    <LabelledToggleField
      className={className}
      name={FormField.OfferDelayedStart}
      size="small"
      label={t('sellerModal.create.offer_delayed_start.label')}
      subLabel={subLabel}
      tooltip={t('sellerModal.create.offer_delayed_start.tooltip')}
      toggleTooltip={
        disabled ? t('sellerModal.create.offer_delayed_start.tooltip.disabled') : undefined
      }
      onChange={() => {}}
      disabled={disabled}
    />
  );
};

OfferDelayedStartToggle.displayName = 'OfferDelayedStartToggle';

export default OfferDelayedStartToggle;
